import React from "react";
import styled from 'styled-components';
import { AiOutlineSearch } from "react-icons/ai";

const BtnVert = styled.a`
text-decoration: none;
border: none;
background: ${props => props.theme.greenST};
display: inline-block; 
text-align: center;
align-items: center; 
justify-content: center;
align-items: center;
padding: 8px;
width: ${props => props.width || "240px"};
margin: ${props => props.margin || "0"};
position: relative;
cursor: pointer;
color: #fff; 
font-size: 17px;
font-weight: 600;
text-transform: uppercase;
transition: all .2s ease-out;

&.search {
  width: auto;
  & >span > svg {
    display: block;
    font-size: 25px;
  }
}
&> span {
  display: block;
  padding: 15px; 
  border: 2px dashed #fff; 
  &> svg {
  display: none;
}
}

  &:hover {
    background: #fff;
    color: ${props => props.theme.greenST};
    text-decoration: none;
    &> span {
      border: 2px dashed ${props => props.theme.greenST};
    }
    
}

@media screen and (max-width: 576px) {
    width: ${props => props.widthMob || "100%"};
    padding: 15px;
    margin: auto;
}
`;


export default function BoutonVertST(props) {


    return <BtnVert className={props.className} margin={props.margin} width={props.width} widthMob={props.widthMob} href={props.href}><span><AiOutlineSearch/>{props.lib}</span></BtnVert>   


}